var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/assets/flags/index.tsx
var flags_exports = {};
__export(flags_exports, {
  Australia: () => au_exports,
  Canada: () => ca_exports,
  France: () => fr_exports,
  Germany: () => de_exports,
  Italy: () => it_exports,
  Netherlands: () => nl_exports,
  Portugal: () => pt_exports,
  Spain: () => es_exports,
  UnitedKingdom: () => gb_exports,
  UnitedStates: () => us_exports,
  Unknown: () => unknown_exports
});

// src/assets/flags/au.svg
var au_exports = {};
__export(au_exports, {
  default: () => au_default
});
var au_default = "./au-IPFTLCVK.svg";

// src/assets/flags/ca.svg
var ca_exports = {};
__export(ca_exports, {
  default: () => ca_default
});
var ca_default = "./ca-K4HM7OFV.svg";

// src/assets/flags/de.svg
var de_exports = {};
__export(de_exports, {
  default: () => de_default
});
var de_default = "./de-FBQL42EQ.svg";

// src/assets/flags/es.svg
var es_exports = {};
__export(es_exports, {
  default: () => es_default
});
var es_default = "./es-OS3KY5Z4.svg";

// src/assets/flags/fr.svg
var fr_exports = {};
__export(fr_exports, {
  default: () => fr_default
});
var fr_default = "./fr-W23DMHRX.svg";

// src/assets/flags/gb.svg
var gb_exports = {};
__export(gb_exports, {
  default: () => gb_default
});
var gb_default = "./gb-2QPEGWWH.svg";

// src/assets/flags/it.svg
var it_exports = {};
__export(it_exports, {
  default: () => it_default
});
var it_default = "./it-665SA4D4.svg";

// src/assets/flags/nl.svg
var nl_exports = {};
__export(nl_exports, {
  default: () => nl_default
});
var nl_default = "./nl-O5LQ7AOD.svg";

// src/assets/flags/pt.svg
var pt_exports = {};
__export(pt_exports, {
  default: () => pt_default
});
var pt_default = "./pt-X77T24QE.svg";

// src/assets/flags/unknown.svg
var unknown_exports = {};
__export(unknown_exports, {
  default: () => unknown_default
});
var unknown_default = "./unknown-ZUTTOI5P.svg";

// src/assets/flags/us.svg
var us_exports = {};
__export(us_exports, {
  default: () => us_default
});
var us_default = "./us-UYK4JT3W.svg";

// src/components/Date.tsx
import { Trans } from "react-i18next";
import { jsx } from "react/jsx-runtime";
var Date = ({
  type = "full",
  date,
  className
}) => {
  return date && /* @__PURE__ */ jsx(
    Trans,
    {
      className,
      i18nKey: type === "full" ? "date.full" : "date.full_time",
      values: { date }
    }
  );
};

// src/components/TransFn.tsx
import { Trans as Trans2 } from "react-i18next";
import { jsx as jsx2 } from "react/jsx-runtime";
function trans(key, props) {
  return /* @__PURE__ */ jsx2(Trans2, __spreadValues({ i18nKey: key }, props));
}

// src/components/SkuTrans.tsx
var SkuTrans_exports = {};
__export(SkuTrans_exports, {
  Trans: () => Trans3,
  getTranslationKey: () => getTranslationKey,
  t: () => t,
  useTranslation: () => useTranslation
});

// src/resources/sku/au.json
var au_default2 = {};

// src/resources/sku/ca.json
var ca_default2 = {};

// src/resources/sku/de.json
var de_default2 = {
  product_class: {
    __name: "Produktklasse",
    LFBK: {
      __name: "Layflat-Fotobuch",
      book_size: {
        __name: "Buchformat",
        "0700x0700": "Kleines Quadrat",
        "0775x0975": "Hochformat",
        "0800x1000": "Standard Hochformat",
        "1000x0800": "Standard Querformat",
        "1200x1200": "Gro\xDFes Quadrat",
        "1300x1100": "Gro\xDFes Querformat"
      },
      cover_type: {
        __name: "Einbandtyp",
        IW: "Hardcover, Umschlag"
      },
      paper_type: {
        __name: "Papier",
        LFEGG: "Mohawk Superfine Eierschalenpapier - Layflat",
        LFPLS: "Premium Seidenmatt - Layflat",
        LFPRL: "Mohawk proPhoto Perlmutt - Layflat"
      }
    },
    MGZN: {
      __name: "Magazin",
      book_size: {
        __name: "Buchformat",
        "0850x1100": "8,5x11"
      },
      cover_type: {
        __name: "Einbandtyp",
        SC: "Softcover"
      },
      paper_type: {
        __name: "Papier",
        MGECO: "\xD6konomie Magazin",
        MGPRM: "Sterling Premium Papier"
      }
    },
    PHBK: {
      __name: "Fotobuch",
      book_size: {
        __name: "Buchformat",
        "0500x0500": "Mini Quadrat",
        "0700x0700": "Kleines Quadrat",
        "0775x0975": "Hochformat",
        "0800x1000": "Standard Hochformat",
        "1000x0800": "Standard Querformat",
        "1200x1200": "Gro\xDFes Quadrat",
        "1300x1100": "Gro\xDFes Querformat"
      },
      cover_type: {
        __name: "Einbandtyp",
        DJ: "Hardcover, Schutzumschlag",
        IW: "Hardcover, Umschlag",
        SC: "Softcover"
      },
      linen_type: {
        __name: "Leineneinband",
        BL: "Standard Schwarz",
        CH: "Kohle (ProLine)",
        NO: "Ohne Leinen",
        OM: "Haferflocken (ProLine)"
      },
      paper_type: {
        __name: "Papier",
        PHSTD: "Standard",
        PMEGG: "Mohawk Superfine Eierschalenpapier",
        PMPRL: "Mohawk proPhoto Perlmutt",
        PPRLS: "Premium, seidenmatt",
        PPRMT: "Premium, matt"
      },
      endsheet_type: {
        __name: "Vorsatzpapier",
        PBL: "Schwarz (ProLine)",
        PCH: "Kohle (ProLine)",
        PGR: "Hellgrau (ProLine)",
        PWH: "Wei\xDF (ProLine)",
        SGR: "Standard Mittelgrau"
      }
    },
    TDBK: {
      __name: "Taschenbuch",
      book_size: {
        __name: "Buchformat",
        "0500x0800": "5x8",
        "0600x0900": "6x9",
        "0800x1000": "8x10"
      },
      cover_type: {
        __name: "Einbandtyp",
        DJ: "Hardcover, Schutzumschlag",
        IW: "Hardcover, Umschlag",
        SC: "Softcover"
      },
      paper_type: {
        __name: "Papier",
        TECBW: "\xD6konomisches Taschenbuch B&W Papier, matt",
        TECCL: "\xD6konomisches Taschenbuchpapier, matt",
        TECCR: "\xD6konomisches Creme Taschenbuch B&W Papier, matt",
        TLGBW: "Schwarz-Wei\xDF-Druck (auf cremefarbenem ungestrichenem Papier)",
        TLGCL: "Farbdruck (auf wei\xDFem ungestrichenem Papier)",
        TSTBW: "Standard Taschenbuch B&W Papier, matt",
        TSTCL: "Standard Taschenbuchpapier, matt"
      }
    },
    WART: {
      __name: "Wandkunst",
      wallart_size: {
        __name: "Format",
        "0800x1000": "Hochformat, 8x10 in., 20,3x25,4 cm",
        "1000x0800": "Querformat, 10x8 in., 25,4x20,3 cm",
        "1100x1400": "Hochformat, 11x14 in., 27,9x35,6 cm",
        "1200x1200": "Quadrat, 12x12 in., 30,5x30,5 cm",
        "1400x1100": "Querformat, 14x11 in., 35,6x27,9 cm",
        "1600x2000": "Hochformat, 16x20 in., 40,6x50,8 cm",
        "2000x1600": "Querformat, 20x16 in., 50,8x40,6 cm",
        "2000x2000": "Quadrat, 20x20 in., 50,8x50,8 cm",
        "2000x2400": "Hochformat, 20x24 in., 50,8x61 cm",
        "2000x3000": "Hochformat, 20x30 in., 50,8x76,2 cm",
        "2400x2000": "Querformat, 24x20 in., 61x50,8 cm",
        "3000x2000": "Querformat, 30x20 in., 76,2x50,8 cm"
      },
      wallart_material: {
        __name: "Typ",
        AC: "Acryldruck",
        CV: "Leinwanddruck",
        MT: "Metalldruck"
      }
    }
  }
};

// src/resources/sku/en.json
var en_default = {
  product_class: {
    __name: "Product Class",
    LFBK: {
      __name: "Layflat Photo Book",
      book_size: {
        __name: "Book Format",
        "0700x0700": "Small Square",
        "0775x0975": "Portrait",
        "0800x1000": "Standard Portrait",
        "1000x0800": "Standard Landscape",
        "1200x1200": "Large Square",
        "1300x1100": "Large Landscape"
      },
      cover_type: {
        __name: "Cover type",
        IW: "Hardcover, Imagewrap"
      },
      paper_type: {
        __name: "Paper type",
        LFEGG: "Mohawk Superfine Eggshell - Layflat",
        LFPLS: "Premium Lustre - Layflat",
        LFPRL: "Mohawk proPhoto Pearl - Layflat"
      },
      logo_type: {
        __name: "Blurb logo",
        NL: "No Blurb logo",
        BP: "Logo on a Black Page",
        WP: "Logo on a White Page"
      }
    },
    MGZN: {
      __name: "Magazine",
      book_size: {
        __name: "Book Format",
        "0850x1100": "8.5x11"
      },
      cover_type: {
        __name: "Cover type",
        SC: "Softcover"
      },
      paper_type: {
        __name: "Paper type",
        MGECO: "Economy Magazine",
        MGPRM: "Sterling Premium Paper"
      }
    },
    PHBK: {
      __name: "Photo Book",
      book_size: {
        __name: "Book Format",
        "0500x0500": "Mini Square",
        "0700x0700": "Small Square",
        "0775x0975": "Portrait",
        "0800x1000": "Standard Portrait",
        "1000x0800": "Standard Landscape",
        "1200x1200": "Large Square",
        "1300x1100": "Large Landscape"
      },
      cover_type: {
        __name: "Cover type",
        DJ: "Hardcover, Dust Jacket",
        IW: "Hardcover, Imagewrap",
        SC: "Softcover"
      },
      linen_type: {
        __name: "Cover Linen",
        BL: "Standard Black",
        CH: "Charcoal (ProLine)",
        NO: "No Linen",
        OM: "Oatmeal (ProLine)"
      },
      paper_type: {
        __name: "Paper type",
        PHSTD: "Standard",
        PMEGG: "Mohawk Superfine Eggshell",
        PMPRL: "Mohawk proPhoto Pearl",
        PPRLS: "Premium, lustre",
        PPRMT: "Premium, matte"
      },
      endsheet_type: {
        __name: "Endsheet",
        PBL: "Black (ProLine)",
        PCH: "Charcoal (ProLine)",
        PGR: "Light Grey (ProLine)",
        PWH: "White (ProLine)",
        SGR: "Standard Mid-Grey",
        NON: "None"
      },
      logo_type: {
        __name: "Blurb logo",
        NL: "No Blurb logo",
        BP: "Logo on a Black Page",
        WP: "Logo on a White Page"
      }
    },
    TDBK: {
      __name: "Trade Book",
      book_size: {
        __name: "Book Format",
        "0500x0800": "5x8",
        "0600x0900": "6x9",
        "0800x1000": "8x10"
      },
      cover_type: {
        __name: "Cover type",
        DJ: "Hardcover, Dust Jacket",
        IW: "Hardcover, Imagewrap",
        SC: "Softcover"
      },
      paper_type: {
        __name: "Paper type",
        TECBW: "Economy Trade B&W Paper, matte finish",
        TECCL: "Economy Trade Paper, matte finish",
        TECCR: "Economy Cream Trade B&W Paper, matte finish",
        TLGBW: "Black and White printing (on cream uncoated paper)",
        TLGCL: "Color printing (on white uncoated paper)",
        TSTBW: "Standard Trade B&W Paper, matte finish",
        TSTCL: "Standard Trade Paper, matte finish"
      }
    },
    WART: {
      __name: "Wall Art",
      wallart_size: {
        __name: "Format",
        "0800x1000": "Portrait, 8x10 in., 20.3x25.4 cm",
        "1000x0800": "Landscape, 10x8 in., 25.4x20.3 cm",
        "1100x1400": "Portrait, 11x14 in., 27.9x35.6 cm",
        "1200x1200": "Square, 12x12 in., 30.5x30.5 cm",
        "1400x1100": "Landscape, 14x11 in., 35.6x27.9 cm",
        "1600x2000": "Portrait, 16x20 in., 40.6x50.8 cm",
        "2000x1600": "Landscape, 20x16 in., 50.8x40.6 cm",
        "2000x2000": "Square, 20x20 in., 50.8x50.8 cm",
        "2000x2400": "Portrait, 20x24 in., 50.8x61 cm",
        "2000x3000": "Portrait, 20x30 in., 50.8x76.2 cm",
        "2400x2000": "Landscape, 24x20 in., 61x50.8 cm",
        "3000x2000": "Landscape, 30x20 in., 76.2x50.8 cm"
      },
      wallart_material: {
        __name: "Type",
        AC: "Acrylic Print",
        CV: "Canvas Print",
        MT: "Metal Print"
      }
    }
  }
};

// src/resources/sku/es.json
var es_default2 = {};

// src/resources/sku/fr.json
var fr_default2 = {};

// src/resources/sku/gb.json
var gb_default2 = {};

// src/resources/sku/it.json
var it_default2 = {};

// src/resources/sku/nl.json
var nl_default2 = {};

// src/resources/sku/pt.json
var pt_default2 = {};

// src/resources/sku/index.ts
var NAMESPACE = "sku";
var sku_default = {
  au: au_default2,
  ca: ca_default2,
  de: de_default2,
  en: en_default,
  es: es_default2,
  fr: fr_default2,
  gb: gb_default2,
  it: it_default2,
  nl: nl_default2,
  pt: pt_default2
};

// src/components/SkuTrans.tsx
import i18next from "i18next";
import {
  Trans as DefaultTrans,
  useTranslation as useDefaultTranslation
} from "react-i18next";
import { jsx as jsx3 } from "react/jsx-runtime";
function getTranslationKey(props) {
  var _a;
  const key = (path) => `product_class.${path}`;
  const productClass = props.productClass;
  const optionType = (_a = props.optionType) == null ? void 0 : _a.toLowerCase();
  const optionValue = props.optionValue;
  if (productClass === void 0) {
    return key("__name");
  }
  if (optionType === void 0) {
    return key(`${productClass}.__name`);
  }
  if (optionValue === void 0) {
    return key(`${productClass}.${optionType}.__name`);
  }
  return key(`${productClass}.${optionType}.${optionValue}`);
}
var Trans3 = (_a) => {
  var _b = _a, { sku } = _b, props = __objRest(_b, ["sku"]);
  return /* @__PURE__ */ jsx3(
    DefaultTrans,
    __spreadValues({
      ns: NAMESPACE,
      i18nKey: getTranslationKey(sku)
    }, props)
  );
};
function useTranslation() {
  const _a = useDefaultTranslation(NAMESPACE), { t: t2 } = _a, props = __objRest(_a, ["t"]);
  return __spreadValues({
    t: (...args) => t2(getTranslationKey(...args))
  }, props);
}
function t(...args) {
  return i18next.t(getTranslationKey(...args), { ns: NAMESPACE });
}

// src/config.ts
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { DateTime } from "luxon";
import { initReactI18next } from "react-i18next";
var supportedLanguages = [
  "de",
  "en",
  "es",
  "es-us",
  "fr",
  "fr-ca",
  "it",
  "nl",
  "pt"
];
var domainToLocaleMap = {
  // Production domains
  "www.blurb.com": "en",
  "blurb.com": "en",
  "au.blurb.com": "en",
  "br.blurb.com": "pt",
  "nl.blurb.com": "nl",
  "it.blurb.com": "it",
  "www.blurb.co.uk": "en",
  "blurb.co.uk": "en",
  "www.blurb.fr": "fr",
  "blurb.fr": "fr",
  "www.blurb.de": "de",
  "blurb.de": "de",
  "www.blurb.es": "es",
  "blurb.es": "es",
  "www.blurb.ca": "en",
  "blurb.ca": "en",
  "fr.blurb.ca": "fr-ca",
  // Master domains
  "master.blurb.com": "en",
  "master-au.blurb.com": "en",
  "master-br.blurb.com": "pt",
  "master-nl.blurb.com": "nl",
  "master-it.blurb.com": "it",
  "master.blurb.co.uk": "en",
  "master.blurb.fr": "fr",
  "master.blurb.de": "de",
  "master.blurb.es": "es",
  "master.blurb.ca": "en",
  "master-fr.blurb.ca": "fr-ca",
  // Integration domains
  "integration.blurb.com": "en",
  "integration-au.blurb.com": "en",
  "integration-br.blurb.com": "pt",
  "integration-nl.blurb.com": "nl",
  "integration-it.blurb.com": "it",
  "integration.blurb.co.uk": "en",
  "integration.blurb.fr": "fr",
  "integration.blurb.de": "de",
  "integration.blurb.es": "es",
  "integration.blurb.ca": "en",
  "integration-fr.blurb.ca": "fr-ca",
  // For local testing
  "de.localhost": "de"
};
var domainDetector = {
  name: "domain",
  lookup() {
    if (typeof window !== "undefined" && window.location) {
      const hostname = window.location.hostname;
      const locale = domainToLocaleMap[hostname];
      if (locale) {
        return locale;
      }
    }
    return void 0;
  }
};
function initI18n(resources) {
  const languageDetector = new LanguageDetector();
  languageDetector.addDetector(domainDetector);
  i18n.use(languageDetector).use(initReactI18next).init({
    debug: true,
    ns: ["translation", NAMESPACE],
    fallbackLng: "en",
    interpolation: {
      escapeValue: false
    },
    detection: {
      caches: ["cookie"],
      lookupQuerystring: "lang",
      lookupCookie: "react-i18next",
      order: ["domain", "querystring", "cookie", "header"]
    },
    resources
  });
  Object.keys(sku_default).forEach((key) => {
    const lang = key;
    const resource = sku_default[lang];
    if (!resource) return;
    i18n.addResourceBundle(lang, NAMESPACE, resource, true, true);
  });
  i18n.services.formatter.add("DATE_FULL", (value, lang) => {
    return DateTime.fromISO(value).setLocale(parseToLuxonLocale(lang)).toLocaleString(DateTime.DATE_FULL);
  });
  i18n.services.formatter.add("DATETIME_FULL", (value, lang) => {
    return DateTime.fromISO(value).setLocale(parseToLuxonLocale(lang)).toLocaleString({
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    });
  });
}
var parseToLuxonLocale = (lang) => {
  if (!lang) return "en-US";
  switch (lang) {
    case "en":
      return "en-US";
    case "gb":
      return "en-GB";
    default:
      return lang;
  }
};

// src/index.ts
import { Trans as Trans4, useTranslation as useTranslation2 } from "react-i18next";
export {
  Date,
  flags_exports as Flag,
  SkuTrans_exports as Sku,
  Trans4 as Trans,
  initI18n,
  supportedLanguages,
  trans,
  useTranslation2 as useTranslation
};
